"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasTokens = void 0;
const useUserData_1 = require("root/src/client/v2/userData/hooks/useUserData");
function useHasTokens() {
    const { userData } = (0, useUserData_1.useUserData)();
    if (!Array.isArray(userData === null || userData === void 0 ? void 0 : userData.tokens)) {
        return { hasTokens: false };
    }
    // TODO maybe add loading from user data here?
    const hasTokens = userData.tokens.length > 0;
    return {
        hasTokens,
    };
}
exports.useHasTokens = useHasTokens;
